// Route guard for the admin's sections (nav.ts `admin`, today Tarkistusjono). The other person
// gets the ordinary "Sivua ei löydy" page: the section is simply not part of their app. Before
// the device knows who is signed in (first start, nothing cached yet) it shows nothing rather
// than a wrong answer; the page appears as soon as /api/me says this is the admin.
import type { ReactNode } from 'react';
import { useIsAdmin } from '../lib/people';
import { useApp } from '../state/store';

export function AdminOnly({ children, fallback }: { children: ReactNode; fallback: ReactNode }) {
  const admin = useIsAdmin();
  const unknown = useApp((s) => s.identity === 'local' && s.phase === 'loading');
  if (admin) return <>{children}</>;
  return unknown ? null : <>{fallback}</>;
}
